<body>
  <div class="container-header">
    <mat-toolbar color="#01BAC9">
      <mat-toolbar-row>
        <span class="logo">
          <a class="navbar-brand" href="/#/inicio">
            <img style="max-height: 53px;" src="assets/images/generico/logo.png" alt="Inicio icono">
          </a>
        </span>
        <span class="example-spacer"></span>
        <div *ngIf="!identity || !token">
          <button class="session_btn" mat-button (click)="sign(true, 'expedientes')">
            <mat-icon mat-button>touch_app</mat-icon>
            Iniciar sesión
          </button>
        </div>
        <div *ngIf="identity || token">
          <button mat-button style="color: black !important" (click)="openPerfil()">
            {{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}
          </button>
          <button mat-button [matMenuTriggerFor]="menu">
            <mat-icon mat-button [matMenuTriggerFor]="menu">settings
            </mat-icon> Opciones
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item href="">
              <mat-icon>build
              </mat-icon>Ajustes
            </button>
            <button mat-menu-item href="" (click)="logout()">
              <mat-icon>exit_to_app
              </mat-icon>Cerrar Sesi&oacute;n
            </button>
          </mat-menu>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  <div class="container mat_step_container" *ngIf="!mostrar_solicitud">

    <mat-card class="example-card">
      <mat-card-header align="center">
        <div class="row" style="width: 100%; height: 150px; margin-bottom: 3%;">
          <!-- <div class="col-xs-12 imgsol">
                <img src="assets/images/titulosolcert.png" alt="">
            </div> -->

          <!--  <div class="col-lg-12 col-md-12 col-xs-12 imgdocs2" style="width: 100%;">
                <img style="width: 100%; height: fit-content;" src="assets/images/exps2.jpg" alt="">
            </div> -->
          <div class="title1"> Constancia de Expediente en Trámite</div>
        </div>
      </mat-card-header>

      <mat-card-content>

        <table class="table-cert">
          <tr class="tr-title">
            <td>
              <p class="table_title">Nombre solicitud</p>
            </td>
            <td>
              <p class="table_title">Valor referencial</p>
            </td>
            <td>
              <p class="table_title">Plazo de entrega</p>
            </td>
          </tr>
          <tr class="tr-info-ult">
            <td>
              Constancia de Expediente en Trámite
            </td>
            <td>
              ${{ valores_cert ? valores_cert.valor_cet : 0 }}
            </td>
            <td>
              Será enviado a su correo en hasta siete días hábiles
            </td>
          </tr>
        </table>
      </mat-card-content>
      <div style="padding: 10px">
        <button class="btn_center" mat-raised-button color="primary"
          (click)="solicitar_Certificados()">Continuar</button>
      </div>
    </mat-card>
  </div>


  <div class="container mat_step_container" *ngIf="mostrar_solicitud">
    <div class="row" align="right">
      <button class="btn_danger" mat-button (click)="cerrar_vista();">Salir</button>
    </div>
    <div class="container">

      <div class="container rut" *ngIf="busqueda">

        <form [formGroup]="firstFormGroup">

          <div class="container alignCenter" *ngIf="pasoUno">
            <h3>Ingrese los datos de búsqueda</h3>
            <div class="row">
              <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">
                <mat-form-field>
                  <mat-label>Número de solicitud </mat-label>
                  <input matInput placeholder="Número de solicitud" formControlName="numX">
                  <mat-error *ngIf="firstFormGroup.controls.numX.errors?.required">
                    El campo es <strong>requerido</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row" *ngIf="!modificando">
              <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">
                <mat-form-field>
                  <mat-label>Rut </mat-label>
                  <input matInput placeholder="Rut" formControlName="rut">
                  <mat-error *ngIf="firstFormGroup.controls.rut.errors?.required">
                    El campo es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="firstFormGroup.controls?.rut.hasError('invalidRut')">
                    Este rut es <strong>inválido</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="!modificando">
              <button mat-raised-button color="primary"
                [disabled]="!firstFormGroup.controls.rut.valid || !firstFormGroup.controls.numX.valid"
                (click)="buscarEstado();">Buscar</button>
            </div>
          </div>

          <div *ngIf="!pasoUno">

            <div class="container_info_rut" *ngIf="primerPaso">
              <div class="row">
                <p class="title_datos"><strong>Datos solicitante</strong></p>
              </div>
              <div class="container_info_rut2">
                <div class="row" style="padding-bottom: 20px">
                  <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>RUT:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.rut }}
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Teléfono:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.telefono }}
                  </div>
                  <hr class="col-lg-10 col-md-10 col-sm-10" />
                </div>
                <div class="row" style="padding-bottom: 20px">
                  <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Solicitante:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.nombre }} {{ info_rut.apellido_p}} {{ info_rut.apellido_m}}
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Celular:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.celular }}
                  </div>
                  <hr class="col-lg-10 col-md-10 col-sm-10" />
                </div>
                <div class="row" style="padding-bottom: 20px">
                  <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Calle:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.calle }}
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Ciudad:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.ciudad }}
                  </div>
                  <hr class="col-lg-10 col-md-10 col-sm-10" />
                </div>
                <div class="row" style="padding-bottom: 20px">
                  <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Número:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.numero }}
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Comuna:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.comuna }}
                  </div>
                  <hr class="col-lg-10 col-md-10 col-sm-10" />
                </div>
                <div class="row" style="padding-bottom: 20px">
                  <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Complemento:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.complemento }}
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Email:</p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.email }}
                  </div>
                  <hr class="col-lg-10 col-md-10 col-sm-10" />
                </div>
              </div>
              <div *ngIf="! firstFormGroup.controls.mod_solicitante.controls.email.valid "
                class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
                <p>El Mail es obligatorio, favor modificar su usuario e ingresar datos
                  válidos.</p>
              </div>
              <div *ngIf="! firstFormGroup.controls.mod_solicitante.controls.cel.valid"
                class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
                <p>El celular es obligatorio, favor modificar su usuario e ingresar datos
                  válidos.</p>
              </div>
              <div *ngIf="! firstFormGroup.controls.mod_solicitante.controls.num.valid"
                class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
                <p>El número de calle es obligatorio, favor modificar su usuario e ingresar datos
                  válidos.</p>
              </div>
            </div>

            <div formGroupName="mod_solicitante" class="container_info_rut" *ngIf="modificando">
              <div class="row title_mod_div" *ngIf="rut_encontrado">
                <strong>
                  <p class="title_mod">Modificando Datos del solicitante</p>
                </strong>
              </div>
              <div class="row title_mod_div" *ngIf="!rut_encontrado">
                <strong>
                  <p class="title_mod">Registrando Datos del solicitante</p>
                </strong>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Nombre *</p>
                  <mat-form-field>
                    <input matInput formControlName="nombre">
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.nombre.errors?.required">
                      El campo es <strong>requerido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Teléfono </p>
                  <mat-form-field>
                    <input matInput formControlName="telefono">
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Apellido Paterno</p>
                  <mat-form-field>
                    <input matInput formControlName="apellido_p">
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Celular *</p>
                  <mat-form-field>
                    <input matInput formControlName="cel">
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.cel.errors?.required">
                      El campo es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.cel.errors?.pattern">
                      Este celular es <strong>inválido</strong>, ejemplo: 945564584
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Apellido Materno</p>
                  <mat-form-field>
                    <input matInput formControlName="apellido_m">
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Ciudad</p>
                  <mat-form-field>
                    <input matInput formControlName="ciudad">
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Calle *</p>
                  <mat-form-field>
                    <input matInput formControlName="calle">
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.calle.errors?.required">
                      El campo es <strong>requerido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Comuna</p>
                  <mat-form-field>
                    <input matInput formControlName="comuna">
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Número *</p>
                  <mat-form-field>
                    <input matInput formControlName="num">
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.num.errors?.required">
                      El campo es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.num.errors?.pattern">
                      Este campo es <strong>inválido</strong>, debe contener solo números.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <p class="title_info">Email *</p>
                  <mat-form-field>
                    <input matInput formControlName="email">
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.email.errors?.required">
                      El campo es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="firstFormGroup.controls.mod_solicitante.controls.email.status === 'INVALID'">
                      Este email es <strong>inválido</strong>, ejemplo: miemail@ejemplo.cl
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-left: 10%; padding-bottom: 2%;">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <p class="title_info">Complemento</p>
                  <mat-form-field>
                    <input matInput formControlName="complemento">
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div *ngIf="!modificando" class="row" style="padding: 0px">
              <div class="col-lg-3 col-md-3 col-sm-3" align="left" style="padding: 0px">
                <button class="btn_danger" mat-raised-button (click)="pasoUno = true">Cancelar</button>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3" align="left" style="padding: 0px">
                <button mat-raised-button color="primary" (click)="mod_inforut()"
                  [disabled]="!rut_encontrado">Modificar</button>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6" align="right" style="padding: 0px">
                <button mat-raised-button color="primary"
                  [disabled]="!this.firstFormGroup.controls.mod_solicitante.valid"
                  (click)="busqueda = false; calcular_total(); muestraInfo();">Continuar</button>
              </div>
            </div>

            <div *ngIf="modificando" class="col-md-12" style="padding: 0px">
              <div class="col-lg-6 col-md-6 col-sm-6" align="left" style="padding: 0px">
                <button class="btn_danger" mat-raised-button (click)="cancelar_mod()">Cancelar</button>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="rut_encontrado" align="right" style="padding: 0px">
                <button mat-raised-button color="primary" (click)="guarda_mod()"
                  [disabled]="!emailValido ||  !this.firstFormGroup.controls.mod_solicitante.valid">Guardar</button>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="!rut_encontrado" align="right" style="padding: 0px">
                <button mat-raised-button color="primary" (click)="registro_sol()"
                  [disabled]="!firstFormGroup.valid">Registrar</button>
              </div>
            </div>

          </div>

        </form>
      </div>


      <div class="container rut" *ngIf="!busqueda">

        <h4>Confirmación</h4>
        <div class="container">
          <div class="row">
            <strong>
              <p class="title_datos">Solicitud de constancia</p>
            </strong>
          </div>
          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-5 col-md-5 col-sm-5">
                <p><i class="material-icons">description</i>Constancia de Expediente en Trámite</p>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-lg-offset-5 col-md-offset-5 col-sm-offset-5">
                <p>${{valores_cert.valor_cet }}</p>
              </div>
            </div>

            <hr class="col-lg-12" />
          </div>

          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Número de solicitud </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.numx }} </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Fecha de creación </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.fecha }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Rol </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.rol }}</p>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Dirección </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.dire }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Nombre del Propietario </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.nombreProp }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row cert_select_info">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> Nombre del Arquitecto </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <p> {{ this.nombreArq }}</p>
              </div>
            </div>

            <hr class="col-lg-12" />
          </div>

          <div class="row">
            <div class="col-lg-12" *ngIf="primerPaso" style="padding-bottom: 20px;">
              <strong>
                <p style="text-align: center;">Un comprobante de solicitud le será enviado al
                  siguiente
                  correo electrónico:
                  {{ info_rut.email }}</p>
              </strong>
            </div>
            <div class="col-lg-12">
              <strong>
                <p style="text-align: center;">El valor total a pagar es: ${{ mostrar_total }}</p>
              </strong>
            </div>
          </div>
          <div class="row" style="padding-left: 2%; padding-right: 2%;">

            <div class="row info_pagar">
              <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">
                <p style="text-align: center;">Para finalizar, deberá presionar el botón
                  "finalizar", se le enviará un correo con las indicaciones con el plazo para el
                  retiro y pago de su solicitud. </p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">
                <p style="text-align: center;">
                  En caso de dudas o consultas, debe comunicarse con el Departamento correspondiente a su expediente
                  en la Dirección de Obras Municipales.
                </p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p style="text-align: center;">
                  Municipalidad de Puente Alto - Dirección de Obras
                </p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p style="text-align: center;">
                  Av. Concha y Toro 1820, Puente Alto, Santiago - Teléfono : +56228101600
                </p>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p style="text-align: center;"><a [href]="link" target="_blank">{{ nombreLink }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="col-lg-6 col-md-6 col-sm-6" align="left">
            <button mat-raised-button color="primary" (click)="busqueda = true">Volver</button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6" align="right">
            <button type="submit" (click)="ingresoFm()" mat-raised-button color="primary" class="btn">
              Finalizar
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
</body>